var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 78,
    viewBox: "0 0 77 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.9987,
    width: 64,
    height: 64,
    rx: 8,
    fill: "#34C347"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_1316_17389)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.66663,
    y: 4,
    width: 64,
    height: 64,
    rx: 8,
    fill: "white",
    fillOpacity: 0.3,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9948 34.334C21.9948 26.0497 28.7105 19.334 36.9948 19.334C45.279 19.334 51.9948 26.0497 51.9948 34.334C51.9948 37.8757 50.7673 41.1307 48.7146 43.6968L54.8399 49.8221C55.4908 50.473 55.4908 51.5283 54.8399 52.1792C54.1891 52.83 53.1338 52.83 52.4829 52.1792L46.3576 46.0538C43.7914 48.1065 40.5364 49.334 36.9948 49.334C28.7105 49.334 21.9948 42.6183 21.9948 34.334ZM36.9948 22.6673C30.5514 22.6673 25.3281 27.8907 25.3281 34.334C25.3281 40.7773 30.5514 46.0007 36.9948 46.0007C43.4381 46.0007 48.6614 40.7773 48.6614 34.334C48.6614 27.8907 43.4381 22.6673 36.9948 22.6673Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6943 27.3889C37.6943 27.0054 37.3834 26.6945 36.9999 26.6945C36.6164 26.6945 36.3055 27.0054 36.3055 27.3889V28.0833H35.611C33.6934 28.0833 32.1388 29.6379 32.1388 31.5556C32.1388 33.4732 33.6934 35.0278 35.611 35.0278H36.3055V39.1945H35.611C34.4604 39.1945 33.5277 38.2617 33.5277 37.1111C33.5277 36.7276 33.2168 36.4167 32.8332 36.4167C32.4497 36.4167 32.1388 36.7276 32.1388 37.1111C32.1388 39.0288 33.6934 40.5833 35.611 40.5833H36.3055V41.2778C36.3055 41.6613 36.6164 41.9722 36.9999 41.9722C37.3834 41.9722 37.6943 41.6613 37.6943 41.2778V40.5833H38.3888C40.3064 40.5833 41.861 39.0288 41.861 37.1111C41.861 35.1935 40.3064 33.6389 38.3888 33.6389H37.6943V29.4722H38.3888C39.5394 29.4722 40.4721 30.405 40.4721 31.5556C40.4721 31.9391 40.783 32.25 41.1666 32.25C41.5501 32.25 41.861 31.9391 41.861 31.5556C41.861 29.6379 40.3064 28.0833 38.3888 28.0833H37.6943V27.3889ZM36.3055 29.4722H35.611C34.4604 29.4722 33.5277 30.405 33.5277 31.5556C33.5277 32.7062 34.4604 33.6389 35.611 33.6389H36.3055V29.4722ZM37.6943 35.0278V39.1945H38.3888C39.5394 39.1945 40.4721 38.2617 40.4721 37.1111C40.4721 35.9605 39.5394 35.0278 38.3888 35.0278H37.6943Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.16663,
    y: 4.5,
    width: 63,
    height: 63,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.1,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_1316_17389",
    x: -5.33337,
    y: -8,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1316_17389"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1316_17389",
    result: "effect2_dropShadow_1316_17389"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1316_17389",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBIcon1);
export default __webpack_public_path__ + "static/media/b_icon-1.10f1a4b469b51823f763a42a5e2e7adf.svg";
export { ForwardRef as ReactComponent };